/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2022 ICEMEDX, Inc.
***********************************************/
import { externaldata } from '../../models/ehr/externaldata';
import { IceMultimediaCanvas } from './IceMultimediaCanvas';
import { IceMultimediaText } from './IceMultimediaText';
import { IcegraffitiData } from './IceMultimediaData';
import { IceMultimediaStroke } from './IceMultimediaStroke';

export class IceMultimediaAttributes {
  fillcolor: string = "red";
  linewidth: number = 2;
  font: string = ""; // this should be a string or font (style) object
  bounding: any = null; // used for bording
  width: number;
  height: number;

  constructor() {
  }

};
